const data = {
	"body": "<path fill=\"currentColor\" d=\"M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm4 11h-4a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2Z\"/>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;
